export class Questionnaire {
    id: number;
    order:number;
    question:string;
    answer: Answers[];
    choosen_answer: string;
}

export class Answer {
    question_id: number;
    answer:string;
    question? : string
}

class Answers {
    content: string;
}


// WEBPACK FOOTER //
// ./src/holiday/models/QuestionAnswer.ts